import React from 'react';
import Editor from '@monaco-editor/react';
import { Modal, ModalVariant } from '@patternfly/react-core';

const CssModal = ({ value, isOpen, onClose }) => {
  return (
    <Modal
      variant={ModalVariant.large}
      title="CSS Editor"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Editor
        height={800}
        defaultLanguage="css"
        value={value}
      />
    </Modal>
  );
};

export default CssModal;
